// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Cxu2h","col":"styles_col__nmrYh"};